<template>
  <div class="animated fadeIn">
      <loader :show="enviando"/>
    <b-card>
      <b-row>
        <b-col sm="12">
          <h4 id="traffic" class="card-title mb-0">Agenda pública</h4>
        </b-col>

        <b-col sm="12" md="12">
            <agenda-publica v-if="idAgenda"
                :id="idAgenda"
                :agendaUsuario="userId"
                @enviandoStart="enviando=true"
                @enviandoStop="enviando=false"
                @cambiaID="cambiaID"/>
        </b-col>

      </b-row>
      
    </b-card>
  </div>
</template>

<script>
import AgendaPublica from '../base/agendaPublica'
import Loader from '../Loader'
import axios from 'axios'
import { mapGetters } from "vuex"

export default {
  name: 'AgendaPublicaMain',
  components: {
    AgendaPublica,
    Loader
  },
  computed: {
        ...mapGetters([
        "httpURL",
        "sessionToken",
        "permisos",
        "role",
        "userId"
        ])
    },
  data: function () {
    return {
        enviando: false,
        idAgenda: null
    }
  },
  created(){
    this.enviando = true;
    //console.log('Solicitando a agenda/usuario/'+this.userId);
    axios.get(this.httpURL+'/comsocial/agenda/usuario/'+this.userId,{headers:{token:this.sessionToken}})
        .then(res => {
            //console.log(res.data);
            this.idAgenda = res.data.agenda._id;
            this.$emit('enviandoStop');
        })
        .catch(error => {
           // console.log(error);
            if(error.response){
                swal("Oops!",error.response.data.mensaje , "error")
            }else if( error.request){
                swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
            }
            this.$emit('enviandoStop');
        });
  },
  methods: {
    cambiaID(payload){
      //console.log('Se asigna '+payload);
      this.idAgenda = payload;
      
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
